import React, { useState, useEffect } from "react";

export default function MonkziLiveSection() {
  const [showChart, setShowChart] = useState(false);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    async function fetchStats() {
      try {
        const res = await fetch("https://api.geckoterminal.com/api/v2/networks/bsc/pools/0xa456bdc4a0800c528cf77c985226de5220747b3e");
        const json = await res.json();
        setStats(json.data.attributes);
      } catch (err) {
        console.error("Failed to fetch MONKZI stats:", err);
      }
    }

    fetchStats();
    const interval = setInterval(fetchStats, 30000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section style={{
      background: "rgba(20, 30, 40, 0.78)",
      borderRadius: "18px",
      padding: "20px",
      color: "#fff",
      margin: "30px 0",
      boxShadow: "0 4px 14px rgba(0,0,0,0.5)"
    }}>
      <h2 style={{ color: "#FFD700", fontWeight: "bold", fontSize: "1.4em", marginBottom: "18px", textAlign: "center" }}>
        {showChart ? "📈 MONKZI 7D Price Chart" : "💹 Live MONKZI Market Stats"}
      </h2>

      <div style={{ textAlign: "center", marginBottom: "14px" }}>
        <button
          onClick={() => setShowChart(false)}
          style={{
            background: showChart ? "#444" : "#FFD700",
            color: showChart ? "#FFD700" : "#191919",
            border: "none",
            padding: "10px 20px",
            marginRight: "8px",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "bold"
          }}
        >
          📊 Stats
        </button>
        <button
          onClick={() => setShowChart(true)}
          style={{
            background: showChart ? "#FFD700" : "#444",
            color: showChart ? "#191919" : "#FFD700",
            border: "none",
            padding: "10px 20px",
            borderRadius: "10px",
            cursor: "pointer",
            fontWeight: "bold"
          }}
        >
          📈 Chart
        </button>
      </div>

      {showChart ? (
        <iframe
          src="https://dexscreener.com/bsc/0xa456bdc4a0800c528cf77c985226de5220747b3e?embed=1&theme=dark"
          width="100%"
          height="300"
          style={{
            border: 0,
            borderRadius: "14px",
            overflow: "hidden",
            maxWidth: "100%",
            boxSizing: "border-box"
          }}
          allowFullScreen
          title="MONKZI Chart"
        ></iframe>
      ) : stats ? (
        <div style={{ fontSize: "1.05em", textAlign: "center", lineHeight: "1.7" }}>
          <p>
  <b>Price (USD):</b>{" "}
  {stats.price_usd
    ? `$${parseFloat(stats.price_usd).toFixed(8)}`
    : "Unavailable"}
</p>
          <p>
  <b>Market Cap:</b>{" "}
  {stats.price_usd
    ? `$${(parseFloat(stats.price_usd) * 1_000_000_000).toLocaleString(undefined, {
        maximumFractionDigits: 0
      })}`
    : "Unavailable"}
</p>
          <p><b>24h Volume:</b> ${parseFloat(stats.volume_usd.h24).toLocaleString()}</p>
          <p>
            <a
              href="https://www.geckoterminal.com/bsc/pools/0xa456bdc4a0800c528cf77c985226de5220747b3e"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#00DC82", textDecoration: "underline", fontWeight: "bold" }}
            >
              View on GeckoTerminal
            </a>
          </p>
        </div>
      ) : (
        <p style={{ color: "#FFD700", textAlign: "center" }}>Loading live stats...</p>
      )}
    </section>
  );
}
